<template>
  <el-dialog
    title="添加团队成员"
    :visible.sync="visible"
    width="500px"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="100px"
      label-position="right"
    >
      <!-- 显示当前小组信息 -->
      <div v-if="groupData" class="group-info">
        <div class="info-label">添加到小组：</div>
        <div class="group-detail">
          <span class="group-name">{{ groupData.name }}</span>
          <span class="current-members">当前成员数：{{ currentMemberCount }}</span>
        </div>
      </div>

      <el-form-item label="选择成员" prop="selectedMemberIds">
        <el-select
          v-model="form.selectedMemberIds"
          placeholder="请选择要添加的团队成员"
          multiple
          filterable
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="user in availableUsers"
            :key="user.id"
            :label="user.screen_name"
            :value="user.id"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class AddMemberDialog extends Vue {
  @Prop({ type: Boolean, default: false }) value
  @Prop({ type: Object, default: null }) groupData
  @Prop({ type: Array, default: () => [] }) users // 用户列表
  @Prop({ type: Array, default: () => [] }) excludeUserIds // 需要过滤的用户ID数组

  visible = false
  loading = false

  form = {
    selectedMemberIds: []
  }

  get rules() {
    return {
      selectedMemberIds: [
        { required: true, message: '请至少选择一名团队成员', trigger: 'change' },
        { type: 'array', min: 1, message: '请至少选择一名团队成员', trigger: 'change' }
      ]
    }
  }

  get currentMemberCount() {
    return this.groupData && this.groupData.team_members ? this.groupData.team_members.length : 0
  }

  get availableUsers() {
    if (!this.users || !this.users.length) return []

    // 获取当前小组的成员ID列表
    const currentMemberIds = (this.groupData && this.groupData.team_members && this.groupData.team_members.map(member => member.id)) || []

    // 合并所有需要过滤的ID（当前小组成员 + 传入的过滤ID数组）
    const allExcludeIds = [...currentMemberIds, ...this.excludeUserIds]

    // 过滤掉所有不可选择的用户
    return this.users.filter(user => !allExcludeIds.includes(user.id))
  }

  @Watch('value')
  onValueChange(val) {
    this.visible = val
    if (val) {
      this.resetForm()
    }
  }

  @Watch('visible')
  onVisibleChange(val) {
    this.$emit('input', val)
  }

  resetForm() {
    this.form = {
      selectedMemberIds: []
    }
    this.$nextTick(() => {
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    })
  }

  handleClose() {
    this.visible = false
    this.resetForm()
  }

  async handleSubmit() {
    try {
      await this.$refs.form.validate()

      if (!this.groupData) {
        this.$message.error('小组信息无效')
        return
      }

      // 获取当前小组的成员ID列表
      const currentMemberIds = (this.groupData.team_members && this.groupData.team_members.map(member => member.id)) || []
      const selectedIds = this.form.selectedMemberIds

      this.loading = true

      // 合并新成员到现有成员列表
      const updatedMemberIds = [...currentMemberIds, ...selectedIds]

      // 构建更新小组的payload
      const payload = {
        name: this.groupData.name,
        kind: this.groupData.kind,
        color: this.groupData.color,
        leader_id: (this.groupData.leader && this.groupData.leader.id) || this.groupData.leader_id,
        merchandiser_id: (this.groupData.merchandiser && this.groupData.merchandiser.id) || this.groupData.merchandiser_id,
        parent_id: this.groupData.parent_id,
        team_member_ids: updatedMemberIds
      }

      // 发送更新请求
      const data = await this.$autoLoading(this.$request.put(`/teams/${this.groupData.id}`, payload))

      this.$message.success(`成功添加 ${selectedIds.length} 名团队成员`)

      // 发射更新事件，传递更新后的小组数据
      this.$emit('members-added', {
        groupId: this.groupData.id,
        updatedGroup: data,
        addedMemberIds: selectedIds
      })

      this.handleClose()
    } catch (error) {
      this.$message.error('添加团队成员失败，请重试')
    } finally {
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}

.group-info {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 20px;
  border-left: 4px solid #409EFF;

  .info-label {
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
  }

  .group-detail {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .group-name {
      font-weight: 500;
      color: #303133;
    }

    .current-members {
      font-size: 12px;
      color: #909399;
    }
  }
}
</style>
